import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

import packageJson from "../../../package.json";

export const PageFooter: React.FC = () => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography variant="caption" className={styles.text}>
        {t("version")}: {packageJson.version}
      </Typography>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    padding: ${theme.spacing(0, 8)};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  text: css`
    color: ${theme.palette.text.secondary};
  `,
});
